document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('is-my-device-compatible-section');
  const tabTitles = section.querySelectorAll('.product-tab-title');
  const tabDescriptions = section.querySelectorAll('.phone-types-description');

  if (!tabTitles.length) return;

  const activateTab = (tab) => {
    const targetId = `${tab.id}-description`;
    const targetDescription = document.getElementById(targetId);

    tabTitles.forEach((t) => t.classList.remove('tab-active'));
    tabDescriptions.forEach((desc) => {
      desc.classList.remove('description-active');
      desc.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('tab-active');
    if (targetDescription) {
      targetDescription.classList.add('description-active');
      targetDescription.setAttribute('aria-selected', 'true');
    }

    tab.parentElement.scrollTo({
      left: tab.offsetLeft - tab.parentElement.offsetWidth / 2 + tab.offsetWidth / 2,
      behavior: 'smooth',
    });
  };

  tabTitles.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      activateTab(tab);
    });
  });

  // Modal elements
  const modal = document.getElementById('deviceModal');
  const closeBtn = modal.querySelector('.device-modal-close');
  const seeAllBtn = document.querySelector('.device-comp-btns .simify-button');
  const searchInput = document.getElementById('deviceSearch');
  const list = document.getElementById('modelList');
  const listItems = list.querySelectorAll('li');

  const openModal = () => {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.classList.remove('show');
    document.body.style.overflow = '';
    searchInput.value = '';
    filterDevices('');
  };

  checkDeviceCompatibilityBtn(seeAllBtn, "See all compatible devices");

  closeBtn.addEventListener('click', closeModal);
  window.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  const filterDevices = (query) => {
    const lowerQuery = query.toLowerCase();

    listItems.forEach((li) => {
      if (!li.classList.contains('title')) {
        const text = li.textContent.toLowerCase();
        li.style.display = text.includes(lowerQuery) ? '' : 'none';
      }
    });

    const titles = list.querySelectorAll('li.title');
    titles.forEach((title) => {
      let next = title.nextElementSibling;
      let hasVisibleModel = false;

      while (next && !next.classList.contains('title')) {
        if (next.style.display !== 'none') {
          hasVisibleModel = true;
          break;
        }
        next = next.nextElementSibling;
      }

      title.style.display = hasVisibleModel ? '' : 'none';
    });
  };

  searchInput.addEventListener('input', (e) => {
    filterDevices(e.target.value);
  });
});
